import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

let cachedSettings = null;
export async function getSiteSettings() {
  if (cachedSettings) return cachedSettings;
  try {
    const { data } = await api.get("/settings");
    cachedSettings = { phone: data.phone, whatsapp: data.whatsapp };
  } catch {
    cachedSettings = { phone: "+919163841785", whatsapp: "+919163841785" };
  }
  return cachedSettings;
}

export const digitsOnly = (num) => (num || "").replace(/[^\d]/g, "");
